import { parse } from "@config/theme";
import { css } from "linaria";
import { rem } from "polished";
export const baseText = parse({
  fontFamily: "openSouceSans"
}, "b10rog9o");
export const bodyRegular = "bovm70i";

require("./Text.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Text.styles.ts");